// extracted by mini-css-extract-plugin
module.exports = {"header":"header-7orRTrAO","user":"user-3-DZsfMl","topAd_box":"topAd_box-XK9imlAL","topAd":"topAd-gbAwsH4j","search_bar":"search_bar-3G4A5-vU","logoAd":"logoAd-3yaZfJ_3"};